import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Card,
    CardContent,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer,
    CircularProgress,
    LinearProgress,
    Chip,
    Button
} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import FilterListIcon from "@material-ui/icons/FilterList";
import { Modal } from "antd";
import Skeleton from "@material-ui/lab/Skeleton";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { DownloadOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";
import { setLGDData } from "../../redux/actions/leadSourceActions";
import LeadSourceTypeBookingsReport from "../leadSourceTypeBookings";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        borderRadius: "12px",
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": { 
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
            backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
    headerCell: {
        background: "#1e3a8a",
        color: "#fff",
        fontWeight: 600,
        textAlign: "center",
        position: "sticky",
        top: 0,
        // Must outrank the frozen first column (zIndex 9) or that column paints
        // over the header as soon as you scroll down.
        zIndex: 10
    },
    // Top-left corner: frozen in both axes, so it has to sit above both the
    // sticky header row and the sticky first column.
    headerCornerCell: {
        left: 0,
        zIndex: 12,
    },
    cell: {
        textAlign: "center",
        fontSize: 13,
        background: "#1e3a8a",
        color: "#fff",
    },
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: "#fafafa"
        },
        "&:hover": {
            backgroundColor: "#eef2ff"
        }
    },
}));

const ORANGE = "#F47E46";
const ORANGE_DARK = "#c1531f";
const ORANGE_LIGHT = "#f2994a";

// Indeterminate bar shown inside whichever card is loading. Matches the page's
// orange accent so the two read as the same system.
const BrandLinearProgress = withStyles(() => ({
    root: { height: 4, borderRadius: 999, backgroundColor: "rgba(244,126,70,0.14)" },
    bar: { borderRadius: 999, background: `linear-gradient(90deg, ${ORANGE_DARK}, ${ORANGE}, ${ORANGE_LIGHT})` },
}))(LinearProgress);

// Rendered (non-commented) column count of the lead-detail modal table. Kept as
// a constant so the skeleton rows and the empty-state colSpan can never drift
// from the header row.
const ACTIVE_MODAL_COLUMNS = 47;

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const LeadsGenerated = (props) => {
    const classes = useStyles();
    const lgdData = useSelector((state) => state.leadSource.lgdData);
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);
    const [store, setStore] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "", dateType: "leadAssignedDate" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedSourceOfLeads, setSelectedSourceOfLeads] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("0");
    const [isLostPostMeeting, setIsLostPostMeeting] = useState("");
    const [selectedSalesWon, setSelectedSalesWon] = useState("");
    const [selectedDesignWon, setSelectedDesignWon] = useState("");
    const [selectedCompletion, setSelectedCompletion] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    // Drives just the modal's own body instead of the app-wide loading overlay,
    // so the dialog can open immediately and explain itself while it fetches.
    const [modalDataLoading, setModalDataLoading] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [tableCsvData, setTableCsvData] = useState([]);
    const tableCsvButtonRef = useRef(null);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [selectedDepartment, setSelectedDepartment] = useState("")
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [onlineSourceOfLeads, setOnlineSourceLeads] = useState([])
    const [offlineSourceOfLeads, setOfflineSourceLeads] = useState([])
    const [selectMode, setSelectMode] = useState("")
    const [leadMode, setLeadMode] = useState("All")
    const [allSourceOfLeadOptions, setAllSourceOfLeadOptions] = useState([])
    const [leadsTableCsvData, setLeadsTableCsvData] = useState([]);
    const leadsTableCsvButtonRef = useRef(null);
    const [lastUsedParams, setLastUsedParams] = useState(null);
    const [isInitialRender, setIsInitialRender] = useState(true);
    const FOURTH_BUTTON_DISABLE_UNTIL_KEY = 'fourthButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [isSpinning, setIsSpinning] = useState(false);
    const [loading, setLoading] = useState(false);
    const formatDate = (date) =>
        date ? moment.utc(date).format("DD-MM-YYYY") : "-";

    // `secondarySources` is an ARRAY of { source, date } on the Lead (see
    // models/lead.js) - a lead can pick up more than one over its life - so the
    // entries are joined rather than read off a single field, and each name
    // carries its own date. A separate date column is not an option: with
    // several sources per lead the date has to travel beside the name it
    // belongs to. Entries whose source never populated are dropped instead of
    // rendering as blanks.
    const formatSecondarySources = (lead, fallback = "NA") => {
        const entries = (lead?.secondarySources || [])
            .filter((entry) => entry?.source?.name)
            .map((entry) => {
                const on = entry?.date ? moment.utc(entry.date).format("DD-MM-YYYY") : "";
                return on ? `${entry.source.name} (${on})` : entry.source.name;
            });
        return entries.length ? entries.join(", ") : fallback;
    };

    useEffect(() => {
        expCenters();
        locations();
        leadsCreated();
        getSourceOfLeads()

    }, []);
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "_id", label: "Lead Id" },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "createdAt", label: "Created At" },
        { key: "leadAssignedDate", label: "Lead Assigned Date" },
        { key: "meetingDate", label: "Meeting Date" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "customerDesignSignOffDate", label: "Design Won Date" },
        { key: "actualCompletionDate", label: "Completed Date" },
        { key: "sourceOfLead", label: "Source Of Lead" },
        { key: "secondarySourceOfLead", label: "Secondary Source Of Lead" },
        { key: "pageURL", label: "Page URL" },
        { key: "clientName", label: "Client Name" },
        // { key: "clientNumber", label: "Client Phone Number" },
        // { key: "clientEmail", label: "Client Email" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Experience Center" },
        { key: "clientAddress", label: "Address" },
        { key: "currentStage", label: "Current Stage" },
        { key: "leadType", label: "Lead Type" },
        { key: "assignTo", label: "Assigned To" },
        { key: "department", label: "Department" },
        { key: "lostPostMeeting", label: "Lost Post Meeting" },
        { key: "tokenPercent", label: "Token % Received" },
        { key: "reqNotCollectedMoveDate", label: "Requirements Not Collected Movement Date" },
        { key: "moveStageRnc", label: "Reason for lead to be in Requirements Not Collected Stage" },
        { key: "verificationStatus", label: "Lead verification status" },
        { key: 'reqCollectionDate', label: 'Requirement Collection Date' },
        { key: 'reqCollectedMoveDate', label: 'Requirements Collected Stage Movement Date' },
        { key: 'reasonStayInRc', label: 'Reason for lead to stay in Requirements Collected Stage' },
        { key: 'detailsScope ', label: 'Scope of work in detail' },
        { key: 'designPreferences ', label: 'Design Preferences Details' },
        { key: 'detailsBudget', label: 'Budget Details' },
        { key: 'detailsTimeline', label: 'Timeline to move into the house' },
        { key: 'possessionDate', label: 'Possession Date' },
        { key: 'attachFloorPlan', label: 'Attach Floor Plan link' },
        { key: 'anyOtherSpecificDetails', label: 'Any other specific details relevant to Decorpot' },
        { key: 'QtSentMoveDate', label: 'Quotation Sent Movement Date' },
        { key: 'reasonDealQt', label: 'Reason for deal to be in Quotation Sent stage' },
        { key: 'cxFittingBudget', label: 'Is Quotation fitting customer budget mentioned' },
        { key: 'planVisitExpZone', label: 'Is customer planning to visit the Experience Zone' },
        { key: "cxMoveTimeline", label: "Cx Move-in Timeline" },
        { key: "possessionStatus", label: "Possession Status" },
        { key: "registrationStatus", label: "Registration Status" },
        { key: "decisionMaker", label: "Decision Maker" },
        { key: "financialReadiness", label: "Financial Readiness" },
        { key: "budgetQuotation", label: "Budget Vs Quotation" },
        { key: "competitorInvolvement", label: "Competitors Involvement" },
        { key: "otherCompetitorValue", label: "Other Competitor" },
        { key: "expectedSalesWonDate", label: "Expected Sales Won Date" },
        { key: 'proposeMeetingType', label: 'Propose Meeting Type' },
        { key: 'proposeMeetingDate', label: 'Propose Meeting Date' },
        { key: 'proposeMeetingParticipant', label: 'Meeting Participant' },
        { key: "ad_id", label: "ad_id" },
        { key: "adset_id", label: "adset_id" },
        { key: "campaign_id", label: "campaign_id" },
        { key: "salesUser", label: "Sales Executive" },
        { key: "salesASM", label: "Sales ASM" },
        { key: "salesManager", label: "Sales Manager" },
        { key: "salesAGM", label: "Sales AGM" },
        { key: "salesDGM", label: "Sales DGM" },
        { key: "prevStage", label: "Stage before Lost" },
        { key: "latestNotesMsg", label: "Latest Notes" },
        { key: "latestNotesDate", label: "Latest Notes Date" },
        { key: "latestDealMsg", label: "Latest Deal Activity" },
        { key: "latestDealDate", label: "Latest Deal Activity Date" },
        { key: "reasonForLost", label: "Reason for Lost" },
        { key: "quotationOpenCount", label: "Total Count Quotation Open by Cx" }

    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    _id: popMonthData[i]?._id || "NA",
                    projectCode: popMonthData[i]?.erpProjectNo || "NA",
                    leadNumber: popMonthData[i]?.lead_no || "NA",
                    meetingDate: popMonthData[i]?.meetingDate ? moment(popMonthData[i]?.meetingDate).format("DD-MM-YYYY") : "-",
                    createdAt: popMonthData[i]?.createdAt
                        ? formatDate(popMonthData[i]?.createdAt)
                        : "NA",
                    leadAssignedDate: popMonthData[i]?.leadAssignedDate
                        ? formatDate(popMonthData[i]?.leadAssignedDate)
                        : "NA",
                    sourceOfLead: popMonthData[i]?.sourceOfLead?.name || "NA",
                    secondarySourceOfLead: formatSecondarySources(popMonthData[i]),
                    pageURL: popMonthData[i]?.pageURL ? popMonthData[i]?.pageURL : "-",
                    clientName: popMonthData[i]?.customerId?.name,
                    // clientNumber: popMonthData[i]?.customerId?.contact_no,
                    // clientEmail: popMonthData[i]?.customerId?.email,
                    clientAddress: popMonthData[i]?.customerId?.address,
                    totalValue:
                        (popMonthData[i].staticSalesWonBudget),
                    location: popMonthData[i]?.experienceCenterId?.locationId?.name,
                    expCtrName: popMonthData[i]?.experienceCenterId?.name,
                    salesWonDate: popMonthData[i]?.leadWonDate
                        ? moment(popMonthData[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    currentStage: popMonthData[i].currentStage ? popMonthData[i]?.currentStage : 'NA',
                    leadType: popMonthData[i].leadType ? popMonthData[i]?.leadType : 'NA',
                    assignTo: popMonthData[i].assignTo?.name ? popMonthData[i]?.assignTo?.name : 'NA',
                    department: popMonthData[i]?.departmentId?.name ? popMonthData[i]?.departmentId?.name : 'NA',
                    designStage: popMonthData[i]?.stage ? popMonthData[i]?.stage : "NA",
                    internalDesignSignOffDate: popMonthData[i]?.internalDesignSignOffDate
                        ? moment(popMonthData[i]?.internalDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    customerDesignSignOffDate: popMonthData[i]?.customerDesignSignOffDate
                        ? moment(popMonthData[i]?.customerDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    designSignOffDate: popMonthData[i]?.customerDesignSignOffDate
                        ? moment(popMonthData[i]?.customerDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    materialDeliveryDate: popMonthData[i]?.materialDispatchedDate
                        ? moment(popMonthData[i]?.materialDispatchedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    actualCompletionDate: popMonthData[i]?.executionCompletionDate
                        ? moment(popMonthData[i]?.executionCompletionDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    lostPostMeeting: popMonthData[i]?.isLost?.length > 0
                        ? popMonthData[i].isLost[0]?.isLostPostMeeting === true
                            ? "Yes"
                            : popMonthData[i].isLost[0]?.isLostPostMeeting === false
                                ? "No"
                                : "NA"
                        : "NA",
                    tokenPercent: popMonthData[i]?.tokenPercent !== null ? popMonthData[i]?.tokenPercent : "NA",
                    reqNotCollectedMoveDate: popMonthData[i]?.salesStageData?.reqNotCollectedData?.moveDateInRnc ? moment(popMonthData[i]?.salesStageData?.reqNotCollectedData?.moveDateInRnc).format("DD-MM-YYYY") : "-",
                    moveStageRnc: popMonthData[i]?.salesStageData?.reqNotCollectedData?.reasonToMove ? popMonthData[i]?.salesStageData?.reqNotCollectedData?.reasonToMove : "-",
                    verificationStatus: popMonthData[i]?.salesStageData?.reqNotCollectedData?.verifyStatus ? popMonthData[i]?.salesStageData?.reqNotCollectedData?.verifyStatus : "NA",
                    reqCollectionDate: popMonthData[i]?.salesStageData?.reqCollectedData?.reqCollectionDate ? moment(popMonthData[i]?.salesStageData?.reqCollectedData?.reqCollectionDate).format('DD-MM-YYYY') : '-',
                    reqCollectedMoveDate: popMonthData[i]?.salesStageData?.reqCollectedData?.moveDateInReqCol ? moment(popMonthData[i]?.salesStageData?.reqCollectedData?.moveDateInReqCol).format('DD-MM-YYYY') : '-',
                    reasonStayInRc: popMonthData[i]?.salesStageData?.reqCollectedData?.reasonMoveRcCollect || '-',
                    detailsScope: popMonthData[i]?.salesStageData?.reqCollectedData?.rcScopeOfWork || '-',
                    designPreferences: popMonthData[i]?.salesStageData?.reqCollectedData?.designPref || '-',
                    detailsBudget: popMonthData[i]?.salesStageData?.reqCollectedData?.estimatedBudget || '-',
                    detailsTimeline: popMonthData[i]?.salesStageData?.reqCollectedData?.timelineMoveHouseDate ? moment(popMonthData[i]?.salesStageData?.reqCollectedData?.timelineMoveHouseDate).format('DD-MM-YYYY') : '-',
                    possessionDate: popMonthData[i]?.salesStageData?.reqCollectedData?.possDate ? moment(popMonthData[i]?.salesStageData?.reqCollectedData?.possDate).format('DD-MM-YYYY') : '-',
                    attachFloorPlan: popMonthData[i]?.salesStageData?.reqCollectedData?.floorPlanAttach || '-',
                    anyOtherSpecificDetails: popMonthData[i]?.salesStageData?.reqCollectedData?.rcOtherDetails || '-',
                    QtSentMoveDate: popMonthData[i]?.salesStageData?.qtSentData?.moveDateQtSent ? moment(popMonthData[i]?.salesStageData?.qtSentData?.moveDateQtSent).format('DD-MM-YYYY') : '-',
                    reasonDealQt: popMonthData[i]?.salesStageData?.qtSentData?.reasonForDealQt || '-',
                    cxFittingBudget: popMonthData[i]?.salesStageData?.qtSentData?.qtFitBudget || '-',
                    planVisitExpZone: popMonthData[i]?.salesStageData?.qtSentData?.cxPlanDateVisitStatus || '-',
                    cxMoveTimeline: popMonthData[i]?.hotDealChecklistData?.cxMoveTimeline || 'NA',
                    possessionStatus: popMonthData[i]?.hotDealChecklistData?.possessionStatus || 'NA',
                    registrationStatus: popMonthData[i]?.hotDealChecklistData?.registrationStatus || 'NA',
                    decisionMaker: popMonthData[i]?.hotDealChecklistData?.decisionMaker || 'NA',
                    financialReadiness: popMonthData[i]?.hotDealChecklistData?.financialReadiness || 'NA',
                    budgetQuotation: popMonthData[i]?.hotDealChecklistData?.budgetQuotation || 'NA',
                    competitorInvolvement: popMonthData[i]?.hotDealChecklistData?.competitorInvolvement || 'NA',
                    otherCompetitorValue: popMonthData[i]?.hotDealChecklistData?.otherCompetitorValue || 'NA',
                    expectedSalesWonDate: popMonthData[i]?.hotDealChecklistData?.expectedSalesWonDate ? moment(popMonthData[i]?.hotDealChecklistData?.expectedSalesWonDate).format('DD-MM-YYYY') : 'NA',
                    proposeMeetingType: popMonthData[i]?.salesStageData?.qtSentMeetingDetail?.proposeMeetingType || 'NA',
                    proposeMeetingDate: popMonthData[i]?.salesStageData?.qtSentMeetingDetail?.proposeMeetingDate ? moment(popMonthData[i]?.salesStageData?.qtSentMeetingDetail?.proposeMeetingDate).format('DD-MM-YYYY') : "NA",
                    proposeMeetingParticipant: popMonthData[i]?.salesStageData?.qtSentMeetingDetail?.meetingParticipant || 'NA',
                    ad_id: popMonthData[i]?.ad_id !== null ? popMonthData[i]?.ad_id : "NA",
                    adset_id: popMonthData[i]?.adset_id !== null ? popMonthData[i]?.adset_id : "NA",
                    campaign_id: popMonthData[i]?.campaign_id !== null ? popMonthData[i]?.campaign_id : "NA",
                    salesUser: popMonthData[i].salesUser?.name ? popMonthData[i]?.salesUser?.name : 'NA',
                    salesASM: popMonthData[i].salesAssistantManager?.name ? popMonthData[i]?.salesAssistantManager?.name : 'NA',
                    salesManager: popMonthData[i].salesManager?.name ? popMonthData[i]?.salesManager?.name : 'NA',
                    salesAGM: popMonthData[i].salesAGM?.name ? popMonthData[i]?.salesAGM?.name : 'NA',
                    salesDGM: popMonthData[i].salesDGM?.name ? popMonthData[i]?.salesDGM?.name : 'NA',
                    prevStage: popMonthData[i].prevStage ? popMonthData[i]?.prevStage : 'Not Lost',
                    latestNotesMsg: popMonthData[i]?.latestNotesMsg  || 'NA',
                    latestNotesDate: popMonthData[i]?.latestNotesDate ? moment(popMonthData[i]?.latestNotesDate).format('DD-MM-YYYY')  : 'NA',
                    latestDealMsg: popMonthData[i]?.latestDealMsg  || 'NA',
                    latestDealDate: popMonthData[i]?.latestDealDate ? moment(popMonthData[i]?.latestDealDate).format('DD-MM-YYYY')  : 'NA',
                    reasonForLost: popMonthData[i]?.reasonForLost ? popMonthData[i]?.reasonForLost : 'Not Lost',
                    quotationOpenCount: popMonthData[i]?.quotationOpenCount ?? 0

                };
                csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.error("csvDownloadHandler error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "createdAt", label: "Created At" },
        { key: "leadAssignedDate", label: "Lead Assigned Date" },
        { key: "sourceOfLead", label: "Source of Lead" },
        { key: "secondarySourceOfLead", label: "Secondary Source of Lead" },
        { key: "clientName", label: "Client Name" },
        // { key: "clientNumber", label: "Client Phone Number" },
        // { key: "clientEmail", label: "Client Email" },
        { key: "assignTo", label: "Assigned To" },
        { key: "address", label: "Address" },
        { key: "value", label: "Value (INR)" },
        { key: "city", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr. Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designWonDate", label: "Design Won Date" },
        { key: "completionDate", label: "Completion Date" },
        { key: "currentDepartment", label: "Current Department" },
        { key: "currentStage", label: "Current Stage" },
        { key: "leadType", label: "Lead Type" },
        { key: "lostPostMeeting", label: "Lost Post Meeting" },
        { key: "tokenPercent", label: "Token % Received" },
        { key: "reqNotCollectedMoveDate", label: "Requirements Not Collected Movement Date" },
        { key: "reasonReqNotCollected", label: "Reason for lead to be in Requirements Not Collected Stage" },
        { key: "verificationStatus", label: "Lead Verification Status" },
        { key: "reqCollectionDate", label: "Requirement Collection Date" },
        { key: "reqCollectedMoveDate", label: "Requirements Collected Stage Movement Date" },
        { key: "reasonStayInRc", label: "Reason for lead to stay in Requirements Collected Stage" },
        { key: "scopeOfWork", label: "Scope of work in detail" },
        { key: "designPreferences", label: "Design Preferences Details" },
        { key: "budgetDetails", label: "Budget Details" },
        { key: "timelineMoveHouse", label: "Timeline to move into the house" },
        { key: "possessionDate", label: "Possession Date" },
        { key: "attachFloorPlan", label: "Attach Floor Plan link" },
        { key: "otherDetails", label: "Any other specific details relevant to Decorpot" },
        { key: "qtSentMoveDate", label: "Quotation Sent Movement Date" },
        { key: "reasonDealQt", label: "Reason for deal to be in Quotation Sent stage" },
        { key: "qtFitBudget", label: "Is Quotation fitting customer budget mentioned" },
        { key: "planVisitExpZone", label: "Is customer planning to visit the Experience Zone" },
        { key: "latestNotesMsg", label: "Latest Notes" },
        { key: "latestNotesDate", label: "Latest Notes Date" },
        { key: "latestDealMsg", label: "Latest Deal Activity" },
        { key: "latestDealDate", label: "Latest Deal Activity Date" }
    ];

    const generateTableCsv = () => {
        try {
            let csvArray = [];
            if (popMonthData && popMonthData.length > 0) {
                popMonthData.forEach((data, i) => {
                    let obj = {
                        serialNo: i + 1,
                        projectCode: data?.erpProjectNo || "NA",
                        leadNumber: data?.lead_no || "NA",
                        createdAt: data?.createdAt ? formatDate(data?.createdAt) : "-",
                        leadAssignedDate: data?.leadAssignedDate ? formatDate(data?.leadAssignedDate) : "-",
                        sourceOfLead: data?.sourceOfLead?.name || "N/A",
                        secondarySourceOfLead: formatSecondarySources(data, "N/A"),
                        clientName: data?.customerId?.name || "N/A",
                        // clientNumber: data?.customerId?.contact_no || "N/A",
                        // clientEmail: data?.customerId?.email || "N/A",
                        assignTo: data?.assignTo?.name || "N/A",
                        address: data?.customerId?.address || "N/A",
                        value: data?.staticSalesWonBudget ? data?.staticSalesWonBudget : "N/A",
                        city: data?.experienceCenterId?.locationId?.name || "N/A",
                        expCtrName: data?.experienceCenterId?.name || "N/A",
                        salesWonDate: data?.leadWonDate ? moment(data?.leadWonDate).format("DD-MM-YYYY") : "-",
                        designWonDate: data?.customerDesignSignOffDate ? moment(data?.customerDesignSignOffDate).format("DD-MM-YYYY") : "-",
                        completionDate: data?.executionCompletionDate ? moment(data?.executionCompletionDate).format("DD-MM-YYYY") : "-",
                        currentDepartment: data?.departmentId ? data.departmentId?.name : 'NA',
                        currentStage: data?.currentStage ? data.currentStage : 'NA',
                        leadType: data?.leadType ? data.leadType : 'NA',
                        lostPostMeeting: data?.isLost?.length > 0
                            ? data.isLost[0]?.isLostPostMeeting === true
                                ? "Yes"
                                : data.isLost[0]?.isLostPostMeeting === false
                                    ? "No"
                                    : "NA"
                            : "NA",
                        tokenPercent: data?.tokenPercent !== null ? data?.tokenPercent : "null",
                        reqNotCollectedMoveDate: data?.salesStageData?.reqNotCollectedData?.moveDateInRnc ? moment(data.salesStageData.reqNotCollectedData.moveDateInRnc).format("DD-MM-YYYY") : "-",
                        reasonReqNotCollected: data?.salesStageData?.reqNotCollectedData?.reasonToMove || "-",
                        verificationStatus: data?.salesStageData?.reqNotCollectedData?.verifyStatus || "-",
                        reqCollectionDate: data?.salesStageData?.reqCollectedData?.reqCollectionDate ? moment(data?.salesStageData?.reqCollectedData?.reqCollectionDate).format('DD-MM-YYYY') : 'NA',
                        reqCollectedMoveDate: data?.salesStageData?.reqCollectedData?.moveDateInReqCol ? moment(data?.salesStageData?.reqCollectedData?.moveDateInReqCol).format('DD-MM-YYYY') : 'NA',
                        reasonStayInRc: data?.salesStageData?.reqCollectedData?.reasonMoveRcCollect || '-',
                        scopeOfWork: data?.salesStageData?.reqCollectedData?.rcScopeOfWork || '-',
                        designPreferences: data?.salesStageData?.reqCollectedData?.designPref || '-',
                        budgetDetails: data?.salesStageData?.reqCollectedData?.estimatedBudget || '-',
                        timelineMoveHouse: data?.salesStageData?.reqCollectedData?.timelineMoveHouseDate ? moment(data?.salesStageData?.reqCollectedData?.timelineMoveHouseDate).format('DD-MM-YYYY') : 'NA',
                        possessionDate: data?.salesStageData?.reqCollectedData?.possDate ? moment(data?.salesStageData?.reqCollectedData?.possDate).format('DD-MM-YYYY') : 'NA',
                        attachFloorPlan: data?.salesStageData?.reqCollectedData?.floorPlanAttach || '-',
                        otherDetails: data?.salesStageData?.reqCollectedData?.rcOtherDetails || '-',
                        qtSentMoveDate: data?.salesStageData?.qtSentData?.moveDateQtSent ? moment(data?.salesStageData?.qtSentData?.moveDateQtSent).format('DD-MM-YYYY') : 'NA',
                        reasonDealQt: data?.salesStageData?.qtSentData?.reasonForDealQt || '-',
                        qtFitBudget: data?.salesStageData?.qtSentData?.qtFitBudget || '-',
                        planVisitExpZone: data?.salesStageData?.qtSentData?.cxPlanDateVisitStatus || '-',
                        latestNotesMsg: data?.latestNotesMsg  || '-',
                        latestNotesDate: moment(data?.latestNotesDate).format('DD-MM-YYYY')  || '-',
                        latestDealMsg : data?.latestDealMsg  || '-',
                        latestDealDate : moment(data?.latestDealDate).format('DD-MM-YYYY')  || '-'
                    };
                    csvArray.push(obj);
                });
            }
            setTableCsvData(csvArray);
            setTimeout(() => {
                tableCsvButtonRef.current.link.click();
            }, 100);
        } catch (error) {
            console.error("Error generating table CSV:", error);
            props?.setSnackInfo("Error generating table CSV", "error");
        }
    };

    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const getSourceOfLeads = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getSourceOfLeads();
            // Items where sourceType is Channel Partner
            const channelPartner = response.data.filter(item => item.sourceType === "Channel Partner");

            // Items where sourceType is NOT Channel Partner
            const others = response.data.filter(item => item.sourceType !== "Channel Partner");

            setOfflineSourceLeads(channelPartner)
            setOnlineSourceLeads(others)

        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const isEqual = (obj1, obj2) => {
        // First check if both objects have the same keys
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        // Check if all keys in obj2 exist in obj1
        for (const key of keys2) {
            if (!keys1.includes(key)) {
                return false;
            }
        }

        // Then compare each key's value
        for (const key in obj1) {
            if (Array.isArray(obj1[key])) {
                // For arrays, check if they have the same length and same items
                if (!Array.isArray(obj2[key]) || obj1[key].length !== obj2[key].length) {
                    return false;
                }

                // For arrays of objects with _id, compare by _id
                if (obj1[key].length > 0 && obj1[key][0]?._id) {
                    const obj1Ids = new Set(obj1[key].map(item => item._id));
                    const obj2Ids = new Set(obj2[key].map(item => item._id));

                    // Check if sets are equal
                    if (obj1Ids.size !== obj2Ids.size) {
                        return false;
                    }

                    for (const id of obj1Ids) {
                        if (!obj2Ids.has(id)) {
                            return false;
                        }
                    }
                } else {
                    // Simple comparison for primitive arrays
                    for (let i = 0; i < obj1[key].length; i++) {
                        if (obj1[key][i] !== obj2[key][i]) {
                            return false;
                        }
                    }
                }
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    };

    const leadsCreated = async (addLocation, addExpCenter, addSourceOfLeads) => {
        let locationData = (addLocation || selectedLocation)?.map((el) => el._id)
        let expCenterData = (addExpCenter || selectedExperienceCenter)?.map((el) => el._id)
        let sourceOfLeadData = (addSourceOfLeads || selectedSourceOfLeads)?.map((el) => el._id)
        let currentObj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userLocation: userDetails.selectedLocation,
            userExpCenter: userDetails.selectedExpCenter,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
            salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
            designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
            completion: selectedCompletion !== "" ? selectedCompletion : "",
            selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        }
        // props.setLoading(true);
        // try {
        //     let response = await HttpService.getLeadsCreated(obj);
        //     setStore(response.data);
        // } catch (error) {
        //     console.log(error, "err")
        //     props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        // }

        // props.setLoading(false);
        // Determine if we need to make API call
        let shouldMakeApiCall = false;

        // Case 1: No lgdData - must call API
        if (!lgdData || lgdData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRender && lastUsedParams && !isEqual(lastUsedParams, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoading(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.getLeadsCreated(currentObj);
                setStore(response.data);
                dispatch(setLGDData(response.data));
            } else {
                // Use existing data
                setStore(lgdData);
            }

            // Always save the current parameters
            setLastUsedParams({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRender) {
                setIsInitialRender(false);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }

        setLoading(false);
    };

    // Add this effect to initialize state from localStorage and handle timer
    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(FOURTH_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeft(remainingTimeInSeconds);
                setIsDisabled(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(FOURTH_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabled(false);
                setTimeLeft(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabled && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(FOURTH_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabled(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabled, timeLeft]);

    // Format time for display
    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    // Replace your existing handleRefreshClick with this
    const handleRefreshClick = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(FOURTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabled(true);
        setTimeLeft(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinning(true);
        getRefreshedData(selectedLocation, selectedExperienceCenter, selectedSourceOfLeads);
        setTimeout(() => {
            setIsSpinning(false);
        }, 1000);
    };

    const getRefreshedData = async (addLocation, addExpCenter, addSourceOfLeads) => {
        let locationData = (addLocation || selectedLocation)?.map((el) => el._id)
        let expCenterData = (addExpCenter || selectedExperienceCenter)?.map((el) => el._id)
        let sourceOfLeadData = (addSourceOfLeads || selectedSourceOfLeads)?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userLocation: userDetails.selectedLocation,
            userExpCenter: userDetails.selectedExpCenter,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
            salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
            designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
            completion: selectedCompletion !== "" ? selectedCompletion : "",
            selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        }
        setLoading(true);
        try {
            let response = await HttpService.getLeadsCreated(obj);
            setStore(response.data);
            dispatch(setLGDData(response.data));
        } catch (error) {
            console.error("getRefreshedData error", error)
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }

        setLoading(false);
    };

    const handleSelectChange = async (event) => {
        setSelectedValue(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let sourceOfLeadData = selectedSourceOfLeads?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
            userExpCenter: userDetails.selectedExpCenter,
            userLocation: userDetails.selectedLocation,
            moveToMarketing: event.target.value !== "" ? event.target.value : "",
            lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
            salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
            designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
            completion: selectedCompletion !== "" ? selectedCompletion : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        }
        setLoading(true);
        try {
            let response = await HttpService.getLeadsCreated(obj);
            setStore(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }

    const handleSelectLostPostMeetingChange = async (event) => {
        setIsLostPostMeeting(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let sourceOfLeadData = selectedSourceOfLeads?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.selectedExpCenter,
            selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
            userLocation: userDetails.selectedLocation,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            lostPostMeeting: event.target.value !== "" ? event.target.value : "",
            salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
            designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
            completion: selectedCompletion !== "" ? selectedCompletion : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        }
        setLoading(true);
        try {
            let response = await HttpService.getLeadsCreated(obj);
            setStore(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }

    const handleSelectSalesWonChange = async (event) => {
        setSelectedSalesWon(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let sourceOfLeadData = selectedSourceOfLeads?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
            userExpCenter: userDetails.selectedExpCenter,
            userLocation: userDetails.selectedLocation,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
            salesWon: event.target.value !== "" ? event.target.value : "",
            designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
            completion: selectedCompletion !== "" ? selectedCompletion : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        }
        setLoading(true);
        try {
            let response = await HttpService.getLeadsCreated(obj);
            setStore(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }

    const handleSelectDesignWonChange = async (event) => {
        setSelectedDesignWon(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let sourceOfLeadData = selectedSourceOfLeads?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.selectedExpCenter,
            selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
            userLocation: userDetails.selectedLocation,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
            salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
            designWon: event.target.value !== "" ? event.target.value : "",
            completion: selectedCompletion !== "" ? selectedCompletion : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        }
        setLoading(true);
        try {
            let response = await HttpService.getLeadsCreated(obj);
            setStore(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }

    const handleSelectCompletionChange = async (event) => {
        setSelectedCompletion(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let sourceOfLeadData = selectedSourceOfLeads?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.selectedExpCenter,
            userLocation: userDetails.selectedLocation,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
            salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
            designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
            completion: event.target.value !== "" ? event.target.value : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        }
        setLoading(true);
        try {
            let response = await HttpService.getLeadsCreated(obj);
            setStore(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }
    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        setPivotDatefilters({
            ...storeDateFilter
        });
        leadsCreated(selectedLocation, selectedExperienceCenter, selectedSourceOfLeads)
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    // const handleSearch = async (value) => {
    //     if (pivot === 'value' || pivot === 'total') {
    //         callFunction(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    //     } else if (pivot === 'overallsummary' || pivot === 'designHoldAnalysis') {
    //         overallsummary(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    //     } else if (pivot === 'lost') {
    //         lostDataAnalysis(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    //     } else if (pivot === 'designSignOffReview') {
    //         designSignOffReview(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    //     } else if (pivot === 'mis') {
    //         misReview()
    //     }
    // }

    const handleSelectDepartment = (event) => {
        setSelectedDepartment(event.target.value)
    }

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }

    const handleMultipleSourceOfLeadsData = (event, newValue) => {
        setSelectedSourceOfLeads(newValue);
        handleSourceOfLeadData(newValue);
    };


    const handleSourceOfLeadData = async (newvalue) => {
        // props.setLoading(true);
        await leadsCreated(selectedLocation, selectedExperienceCenter, newvalue)
        // props.setLoading(false);
    }

    const handleExpData = async (newvalue) => {
        // props.setLoading(true);
        await leadsCreated(selectedLocation, newvalue, selectedSourceOfLeads)
        // props.setLoading(false);
    }

    const handleMultipleLocationData = (e, newvalue) => {
        setSelectedLocation(newvalue)
        handleLocationData(newvalue)
    }
    const handleLocationData = async (newvalue) => {
        // props.setLoading(true);
        await leadsCreated(newvalue, selectedExperienceCenter, selectedSourceOfLeads)
        // props.setLoading(false);
    }

    const handleMultipleUsers = (e, newvalue) => {
        setSelectedUsers(newvalue)
    }

    const handleLeadMode = async (event) => {
        setLeadMode(event.target.value)
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let sourceOfLeadData = selectedSourceOfLeads?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.selectedExpCenter,
            userLocation: userDetails.selectedLocation,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
            salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
            designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
            completion: selectedCompletion !== "" ? selectedCompletion : "",
            selectedLeadMode: event.target.value ? event.target.value : "All",
        }
        setLoading(true);
        try {
            let response = await HttpService.getLeadsCreated(obj);
            setStore(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    };

    const getDataBasedOnClickMarketing = async (e, month, innerEl, ids, val) => {
        let obj = {}
        let expCenterData =
            selectedExperienceCenter && selectedExperienceCenter.length > 0
                ? selectedExperienceCenter.map((el) => el._id)
                : "";
        let locationData =
            selectedLocation && selectedLocation.length > 0
                ? selectedLocation.map((el) => el._id)
                : "";
        let sourceOfLeadData =
            selectedSourceOfLeads && selectedSourceOfLeads.length > 0
                ? selectedSourceOfLeads.map((el) => el._id)
                : "";
        if (val === 'leads') {
            obj = {
                _id: { month: month.monthNumber, year: month.year },
                dateInfo: storeDateFilter,
                selectedLocation: innerEl.locationId ? innerEl.locationId : locationData,
                selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
                userLocation: userDetails.selectedLocation,
                userExpCenter: userDetails.experienceCenterId,
                moveToMarketing: selectedValue !== "" ? selectedValue : "",
                lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
                salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
                designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
                completion: selectedCompletion !== "" ? selectedCompletion : "",
                selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
                selectedLeadMode: leadMode ? leadMode : "All",
                leadIds: ids
            }
        } else if (val === 'total') {
            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endMonth: month[month.length - 1].monthNumber, endYear: month[month.length - 1].year },
                    dateInfo: storeDateFilter,
                    selectedLocation: locationData,
                    selectedExperienceCenter: expCenterData,
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    moveToMarketing: selectedValue !== "" ? selectedValue : "",
                    lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
                    salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
                    designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
                    completion: selectedCompletion !== "" ? selectedCompletion : "",
                    selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
                    selectedLeadMode: leadMode ? leadMode : "All",
                    leadIds: ids
                }
            } else {
                let expCenter;
                for (let i = 0; i < store.length; i++) {
                    if (store[i].experienceCenterName === innerEl) {
                        expCenter = store[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endMonth: month[month.length - 1].monthNumber, endYear: month[month.length - 1].year },
                    dateInfo: storeDateFilter,
                    selectedLocation: locationData,
                    selectedExperienceCenter: expCenter,
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    moveToMarketing: selectedValue !== "" ? selectedValue : "",
                    lostPostMeeting: isLostPostMeeting !== "" ? isLostPostMeeting : "",
                    salesWon: selectedSalesWon !== "" ? selectedSalesWon : "",
                    designWon: selectedDesignWon !== "" ? selectedDesignWon : "",
                    completion: selectedCompletion !== "" ? selectedCompletion : "",
                    selectedSourceOfLead: sourceOfLeadData ? sourceOfLeadData : "",
                    selectedLeadMode: leadMode ? leadMode : "All",
                    leadIds: ids
                }
            }
        }
        // Open the dialog right away and let it show its own loader, instead of
        // blocking behind the app-wide overlay until data arrives - feels
        // immediate, and the modal communicates its own state.
        setPopMonthData([]);
        setShowDetailedModal(true);
        setModalDataLoading(true);
        try {
            let response = await HttpService.getDataBasedClickMarketing(obj);
            setPopMonthData(response.data)
        } catch (error) {
            console.error("getDataBasedOnClickMarketing Error ->", error)
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setModalDataLoading(false);
    }

    // Plain-English description of every filter that is actually narrowing the
    // query. Filters still sitting at their default are deliberately left out -
    // listing all fourteen would bury the one or two that are really excluding
    // the data, which is the whole point of showing them.
    const describeActiveFilters = () => {
        const chips = [];
        const names = (list) => (list || []).map((el) => el?.name).filter(Boolean).join(", ");

        if (storeDateFilter.startDate || storeDateFilter.endDate) {
            chips.push({
                label: storeDateFilter.dateType === "createdAt" ? "Created Date" : "Lead Assigned",
                value: `${storeDateFilter.startDate || "any"} → ${storeDateFilter.endDate || "any"}`,
            });
        }
        if (selectedExperienceCenter?.length)
            chips.push({ label: "Exp. Centre", value: names(selectedExperienceCenter) });
        if (selectedLocation?.length)
            chips.push({ label: "City", value: names(selectedLocation) });
        if (selectedSourceOfLeads?.length)
            chips.push({ label: "Source of Lead", value: names(selectedSourceOfLeads) });
        // "2" is the All option, so only an explicit Yes/No is a real filter.
        if (selectedValue === "1" || selectedValue === "0")
            chips.push({ label: "Move to Marketing", value: selectedValue === "1" ? "Yes" : "No" });
        if (isLostPostMeeting) chips.push({ label: "Lost Post Meeting", value: isLostPostMeeting });
        if (selectedSalesWon) chips.push({ label: "Sales Won", value: selectedSalesWon });
        if (selectedDesignWon) chips.push({ label: "Design Won", value: selectedDesignWon });
        if (selectedCompletion) chips.push({ label: "Completion", value: selectedCompletion });
        if (leadMode && leadMode !== "All") chips.push({ label: "Lead Mode", value: leadMode });
        return chips;
    };

    // Shared empty state for the pivot table and the lead modal. Both used to
    // render a bare grid with nothing in it, which reads as a broken page rather
    // than as a filter combination that matched nothing.
    const renderNoDataState = ({ title, hint }) => {
        const chips = describeActiveFilters();
        return (
            <div style={{ textAlign: "center", padding: "44px 24px" }}>
                <div
                    style={{
                        width: 62,
                        height: 62,
                        borderRadius: "50%",
                        margin: "0 auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#FFF1EA",
                        border: `1px solid ${ORANGE}33`,
                    }}
                >
                    <FilterListIcon style={{ fontSize: 30, color: ORANGE_DARK }} />
                </div>
                <div style={{ fontSize: 16, fontWeight: 700, color: "#334155", marginTop: 14 }}>
                    {title}
                </div>
                <div style={{ fontSize: 12.5, color: "#94a3b8", marginTop: 5 }}>{hint}</div>

                {chips.length > 0 ? (
                    <>
                        <div
                            style={{
                                fontSize: 11,
                                fontWeight: 700,
                                letterSpacing: 0.7,
                                textTransform: "uppercase",
                                color: "#94a3b8",
                                margin: "22px 0 9px",
                            }}
                        >
                            Filters currently applied
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 8,
                                justifyContent: "center",
                                maxWidth: 780,
                                margin: "0 auto",
                            }}
                        >
                            {chips.map((chip) => (
                                <Chip
                                    key={chip.label}
                                    size="small"
                                    label={
                                        <span style={{ fontSize: 12 }}>
                                            <span style={{ color: "#94a3b8" }}>{chip.label}:</span>{" "}
                                            <strong style={{ color: "#334155" }}>{chip.value}</strong>
                                        </span>
                                    }
                                    style={{
                                        background: "#fff",
                                        border: "1px solid #e2e8f0",
                                        maxWidth: 340,
                                    }}
                                />
                            ))}
                        </div>
                        <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 18 }}>
                            Widen the date range or remove one of the filters above to see more leads.
                        </div>
                    </>
                ) : (
                    <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 14 }}>
                        No filters are narrowing this view — there are simply no leads to show.
                    </div>
                )}
            </div>
        );
    };

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    // Function to generate CSV data from the leads table - matching exact table structure
    const generateLeadsTableCsv = () => {
        try {
            if (!store || store.length === 0 || !store[0]?.monthlyGrandTotal) {
                setLeadsTableCsvData([]);
                return;
            }

            // Build expCenterData exactly as shown in table
            const expCenterData = {};
            store.forEach((el) => {
                if (!expCenterData[el.experienceCenterName]) {
                    expCenterData[el.experienceCenterName] = [];
                }
                expCenterData[el.experienceCenterName].push(el);
            });

            const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
            const uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));

            // Get header experience centers exactly as shown in table: store.slice(0, uniqueexperienceCenterCode.length - 1)
            const headerExpCenters = store.slice(0, uniqueexperienceCenterCode.length - 1);

            // Create rows for each month - matching exact table structure
            const csvRows = store[0].monthlyGrandTotal.map((month) => {
                const row = {};
                row["Lead Generated Month"] = `${month.monthName.slice(0, 3)}-${month.year % 100} `;

                // Build data columns exactly as shown in table: uniqueexperienceCenterNames.map -> expCenterData[experienceCenterName].map
                // But only include columns that match the headers
                let totalForMonth = 0;
                headerExpCenters.forEach((headerItem) => {
                    // Find matching data for this header expCenterCode
                    let cellValue = 0;
                    uniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        expCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode === headerItem.expCenterCode) {
                                const count = innerEl.monthlyGrandTotal.find(
                                    (entry) => entry.monthName === month.monthName && entry.year === month.year
                                )?.count || 0;
                                cellValue += count;
                            }
                        });
                    });
                    row[headerItem.expCenterCode] = formatNumberToTwoDecimalPlaces(cellValue);
                    totalForMonth += cellValue;
                });

                // Calculate grand total for the month (sum of all displayed columns)
                row["Grand Total"] = formatNumberToTwoDecimalPlaces(totalForMonth);

                return row;
            });

            // Add Grand Total row - matching exact table calculation
            // Table Grand Total row loops through uniqueexperienceCenterNames and shows one cell per name
            // But we need to map these to the header columns
            const grandTotalRow = {};
            grandTotalRow["Lead Generated Month"] = "Grand Total";

            // Calculate totals for each header column
            // For each header, sum all store items that match any expCenterCode in that header's experience center
            let overallGrandTotal = 0;
            headerExpCenters.forEach((headerItem) => {
                // Find which experienceCenterName this header belongs to
                const matchingExpCenterName = uniqueexperienceCenterNames.find((name) => {
                    return expCenterData[name]?.some((el) => el.expCenterCode === headerItem.expCenterCode);
                });

                if (matchingExpCenterName) {
                    // Match exact calculation from table: store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.count : 0), 0)
                    const total = store.reduce((total, el) => {
                        return total + (el.experienceCenterName === matchingExpCenterName ? el.count : 0);
                    }, 0);
                    grandTotalRow[headerItem.expCenterCode] = formatNumberToTwoDecimalPlaces(total);
                    overallGrandTotal += total;
                } else {
                    grandTotalRow[headerItem.expCenterCode] = formatNumberToTwoDecimalPlaces(0);
                }
            });

            // Grand Total column value (sum of all experience centers)
            grandTotalRow["Grand Total"] = formatNumberToTwoDecimalPlaces(overallGrandTotal);

            csvRows.push(grandTotalRow);
            setLeadsTableCsvData(csvRows);
        } catch (error) {
            console.error("Error generating leads table CSV:", error);
            props?.setSnackInfo("Error generating leads table CSV", "error");
        }
    };

    // Generate CSV data when store changes
    React.useEffect(() => {
        if (store && store.length > 0 && store[0]?.monthlyGrandTotal) {
            generateLeadsTableCsv();
        }
    }, [store]);

    const isMarketingAnalyst = userDetails.roles.some(
        (user) => user.name === ROLENAME.marketingAnalyst
    )

    return (
        <div className="App">
            <br />
            <Card
                style={{
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    marginBottom: "16px"
                }}
            >
                <CardContent style={{ padding: "20px" }}>

                    {/* HEADER */}
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ marginBottom: "15px" }}
                    >
                        <Grid
                            item
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                            }}
                        >
                            <FilterListIcon style={{ color: "#1C375D" }} />

                            <h2
                                style={{
                                    margin: 0,
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    color: "#1C375D"
                                }}
                            >
                                Filters
                            </h2>
                        </Grid>
                        {loading && (
                            <Grid item>
                                <Chip
                                    size="small"
                                    // Chip takes `icon`, not `startIcon` (that's a
                                    // Button prop). The negative right margin undoes
                                    // MUI's default icon spacing, which is sized for
                                    // a glyph rather than a spinner.
                                    icon={
                                        <CircularProgress
                                            size={11}
                                            thickness={6}
                                            style={{ color: ORANGE_DARK, marginLeft: 8, marginRight: -2 }}
                                        />
                                    }
                                    label="Fetching data…"
                                    style={{
                                        fontWeight: 700,
                                        fontSize: 11,
                                        background: "#FFF1EA",
                                        color: ORANGE_DARK,
                                        border: `1px solid ${ORANGE}44`,
                                    }}
                                />
                            </Grid>
                        )}
                    </Grid>

                    {/* Reserved slot - keeps the card a fixed height so the page
                        doesn't shift when a fetch starts. */}
                    <div style={{ height: 4, borderRadius: 999, overflow: "hidden", margin: "0 0 14px" }}>
                        {loading ? <BrandLinearProgress /> : null}
                    </div>

                    {/* ROW 1 */}
                    <Grid
                        container
                        spacing={2}
                        // Every control is individually disabled too; this also
                        // stops clicks landing in the gaps between them.
                        style={{ opacity: loading ? 0.55 : 1, pointerEvents: loading ? "none" : "auto", transition: "opacity .2s ease" }}
                    >

                        <Grid item xs={12} sm={2}>
                            <Autocomplete
                                multiple
                                disabled={loading}
                                value={selectedLocation}
                                onChange={handleMultipleLocationData}
                                options={commonLocation}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Location"
                                        variant="outlined"
                                        size="small"
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <Autocomplete
                                multiple
                                disabled={loading}
                                value={selectedExperienceCenter}
                                onChange={handleMultipleExpData}
                                options={commonExpCenter}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Exp-Center"
                                        variant="outlined"
                                        size="small"
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Date Type"
                                disabled={loading}
                                name="dateType"
                                size="small"
                                variant="outlined"
                                value={storeDateFilter.dateType}
                                onChange={storePivotDate}
                                fullWidth
                            >
                                <MenuItem value="leadAssignedDate">Lead Assigned</MenuItem>
                                <MenuItem value="createdAt">Created Date</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="From Date"
                                disabled={loading}
                                type="date"
                                size="small"
                                variant="outlined"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="To Date"
                                disabled={loading}
                                type="date"
                                size="small"
                                variant="outlined"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <Button
                                fullWidth
                                size="small"
                                variant="contained"
                                onClick={handlePivotDateFilter}
                                disabled={loading}
                                startIcon={loading ? <CircularProgress size={15} color="inherit" /> : null}
                                style={{
                                    backgroundColor: loading ? "#c9d0db" : "#F47E46",
                                    color: "#fff",
                                    height: "40px",
                                    borderRadius: "6px",
                                    textTransform: "none",
                                    fontWeight: 500
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>

                    {/* ROW 2 */}
                    <Grid
                        container
                        spacing={2}
                        style={{
                            marginTop: "10px",
                            opacity: loading ? 0.55 : 1,
                            pointerEvents: loading ? "none" : "auto",
                            transition: "opacity .2s ease",
                        }}
                    >

                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Move to Marketing"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                value={selectedValue}
                                onChange={handleSelectChange}
                                fullWidth
                            >
                                <MenuItem value="2">All</MenuItem>
                                <MenuItem value="1">YES</MenuItem>
                                <MenuItem value="0">NO</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Lost Post Meeting"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                value={isLostPostMeeting}
                                onChange={handleSelectLostPostMeetingChange}
                                fullWidth
                            >
                                <MenuItem value="Yes">YES</MenuItem>
                                <MenuItem value="No">NO</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Sales Won"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                value={selectedSalesWon}
                                onChange={handleSelectSalesWonChange}
                                fullWidth
                            >
                                <MenuItem value="Yes">YES</MenuItem>
                                <MenuItem value="No">NO</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Design Won"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                value={selectedDesignWon}
                                onChange={handleSelectDesignWonChange}
                                fullWidth
                            >
                                <MenuItem value="Yes">YES</MenuItem>
                                <MenuItem value="No">NO</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Completion"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                value={selectedCompletion}
                                onChange={handleSelectCompletionChange}
                                fullWidth
                            >
                                <MenuItem value="Yes">YES</MenuItem>
                                <MenuItem value="No">NO</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>

                    {/* ROW 3 */}
                    <Grid container spacing={2} style={{ marginTop: "10px" }}>

                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Modes"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                value={selectMode}
                                onChange={(e) => setSelectMode(e.target.value)}
                                fullWidth
                            >
                                <MenuItem value="online">Online</MenuItem>
                                <MenuItem value="offline">Offline</MenuItem>
                            </TextField>
                        </Grid>

                        {selectMode !== "" && (
                            <Grid item xs={12} sm={2}>
                                <Autocomplete
                                    multiple
                                disabled={loading}
                                    value={selectedSourceOfLeads || []}
                                    options={
                                        selectMode === "online"
                                            ? onlineSourceOfLeads
                                            : offlineSourceOfLeads
                                    }
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        option._id === value._id
                                    }
                                    onChange={(event, newValue) => {
                                        setSelectedSourceOfLeads(newValue);
                                        handleSourceOfLeadData(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Source of Leads"
                                            size="small"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Lead Mode"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                value={leadMode}
                                onChange={handleLeadMode}
                                fullWidth
                            >
                                <MenuItem value="All">All</MenuItem>
                                <MenuItem value="Automation">Automation</MenuItem>
                                <MenuItem value="Manual">Manual</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>

                </CardContent>
            </Card>

            <div style={{ paddingTop: "20px" }}>
                <Paper
                    elevation={4}
                    style={{
                        padding: "20px",
                        borderRadius: "12px",
                        transition: "0.3s ease",
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)"}
                    onMouseLeave={(e) => e.currentTarget.style.boxShadow = ""}
                >
                    <Card
                        style={{
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            marginBottom: "3px"
                        }}
                    >
                        <CardContent style={{ padding: "16px 20px" }}>
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                {/* LEFT: Title + Icon */}
                                <Grid
                                    item
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}
                                >
                                    <TrendingUpIcon style={{ color: "#2e7d32" }} />

                                    <h2
                                        style={{
                                            margin: 0,
                                            fontWeight: 600,
                                            fontSize: "18px"
                                        }}
                                    >
                                        Leads Generated Dashboard
                                    </h2>
                                </Grid>

                                {/* RIGHT: Buttons */}
                                <Grid
                                    item
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                        alignItems: "center"
                                    }}
                                >
                                    <Button
                                        onClick={handleRefreshClick}
                                        variant="contained"
                                        startIcon={<RefreshIcon />}
                                        disabled={isDisabled}
                                        style={{
                                            backgroundColor: isDisabled ? "#cccccc" : "#F47E46",
                                            color: "#FFF2EB",
                                            height: "36px",
                                            textTransform: "none",
                                            borderRadius: "6px"
                                        }}
                                    >
                                        {isDisabled
                                            ? `Wait (${formatTimeLeft()})`
                                            : "Fetch New Data"}
                                    </Button>

                                    <CSVLink
                                        data={leadsTableCsvData}
                                        filename={`Total_No_of_Leads_Generated_${moment().format('YYYY-MM-DD')}.csv`}
                                        ref={leadsTableCsvButtonRef}
                                        style={{ display: "none" }}
                                    />

                                    <Button
                                        variant='contained'
                                        size="small"
                                        startIcon={<DownloadOutlined />}
                                        style={{
                                            backgroundColor: "#355025",
                                            color: "#FFF2EB",
                                            height: "36px",
                                            textTransform: "none",
                                            borderRadius: "6px"
                                        }}
                                        onClick={() => {
                                            generateLeadsTableCsv();
                                            setTimeout(() => {
                                                if (
                                                    leadsTableCsvButtonRef.current &&
                                                    leadsTableCsvData.length > 0
                                                ) {
                                                    leadsTableCsvButtonRef.current.link.click();
                                                }
                                            }, 200);
                                        }}
                                    >
                                        Download CSV
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    {/* Not a scroll container any more: when this scrolled at 500px
                        AND the TableContainer scrolled at 68vh, the outer one is what
                        actually moved, so the header stuck to a container that never
                        scrolled. The 500px bound moved down onto the table itself, so
                        the page stays exactly as tall as before. */}
                    <div>
                        {/* Visible even when the filter card has scrolled away. */}
                        <div style={{ height: 4, borderRadius: 999, overflow: "hidden", margin: "26px 0 0" }}>
                            {loading ? <BrandLinearProgress /> : null}
                        </div>

                        {/* Same banner the lead modal uses - the skeleton rows below
                            show shape but not intent, so this says what is happening. */}
                        {loading && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    marginTop: 10,
                                    padding: "10px 14px",
                                    borderRadius: 10,
                                    background: "#FFF4ED",
                                    border: "1px solid #f6d3bd",
                                }}
                            >
                                <CircularProgress size={17} thickness={5} style={{ color: ORANGE_DARK }} />
                                <div style={{ minWidth: 0 }}>
                                    <div style={{ fontSize: 13, fontWeight: 700, color: ORANGE_DARK }}>
                                        Fetching lead data…
                                    </div>
                                    <div style={{ fontSize: 11.5, color: "#7a6a60" }}>
                                        Building the month-by-month breakdown — this can take a few seconds on a wide date range.
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* maxHeight + overflow give the sticky header a scroll
                            container to stick inside; without one it had nothing to
                            anchor to. Horizontal scroll is contained here too, so the
                            frozen first column stays put on a wide table. */}
                        <TableContainer
                            component={Paper}
                            classes={{ root: classes.customTableContainer }}
                            style={{ marginTop: '8px', borderRadius: '12px', maxHeight: '500px', overflow: 'auto' }}
                        >
                            <Table style={{ minWidth: '600px' }}>

                                {/* Sticky lives on the cells (classes.headerCell), not
                                    here - a sticky <thead> is not reliable, and the
                                    corner cell needs to stick on both axes. */}
                                <TableHead style={{ background: 'white' }}>
                                    <TableRow>
                                        <TableCell className={`${classes.headerCell} ${classes.headerCornerCell}`}>
                                            Month And Year
                                        </TableCell>

                                        {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                                            <TableCell
                                                className={classes.headerCell}
                                                key={index}
                                            // style={{
                                            //     fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                                            //     fontWeight: index === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                            //     textAlign: 'center',
                                            //     position: 'sticky',
                                            //     cursor: 'pointer',
                                            //     top: 0,
                                            //     zIndex: 1,
                                            // }}
                                            >
                                                <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                                                    <span style={{ cursor: "pointer" }}>
                                                        {experienceCenterName.expCenterCode}
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                        ))}
                                        <TableCell className={classes.headerCell}>
                                            Grand Total
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {/* This second TableHead actually holds the DATA rows.
                                    It was also sticky at top:0, so it rode up and sat
                                    on top of the real header - only the header above
                                    should stick. */}
                                <TableHead style={{ background: 'white' }}>
                                    {loading ? (
                                        // Placeholder rows shaped like the real grid,
                                        // so the table keeps its height and column
                                        // rhythm instead of collapsing to a single
                                        // spinner and snapping back. Falls back to 6
                                        // columns on a first load, when the exp-centre
                                        // list is still empty.
                                        Array.from({ length: 7 }).map((_, r) => (
                                            <TableRow key={`sk-${r}`}>
                                                {Array.from({
                                                    length: (uniqueexperienceCenterNames.length || 5) + 1,
                                                }).map((__, c) => (
                                                    <TableCell key={c} style={{ padding: "14px 10px" }}>
                                                        <Skeleton
                                                            variant="text"
                                                            width={c === 0 ? 74 : 46}
                                                            style={c === 0 ? undefined : { margin: "0 auto" }}
                                                        />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    ) : !store?.length || !store[0]?.monthlyGrandTotal?.length ? (
                                        // Without this the grid rendered a lone
                                        // "Grand Total" label and nothing else, which
                                        // looks like a failure rather than an empty
                                        // result. colSpan tracks the header, which is
                                        // Month + one column per centre + Grand Total.
                                        <TableRow>
                                            <TableCell
                                                colSpan={Math.max(2, (uniqueexperienceCenterNames?.length || 0) + 1)}
                                                style={{ borderBottom: "none" }}
                                            >
                                                {renderNoDataState({
                                                    title: "No leads match these filters",
                                                    hint: "Nothing was generated in this period for the selection below.",
                                                })}
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        <>
                                            {store[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                                <TableRow key={monthIndex} className={classes.row}>
                                                    <TableCell className={classes.cell} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>
                                                        <strong>{`${month.monthName.slice(0, 3)}-${month.year % 100}`}</strong>
                                                    </TableCell>

                                                    {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                        <>
                                                            {expCenterData[experienceCenterName].map((innerEl, dataIndex) => {

                                                                const monthlyData = innerEl.monthlyGrandTotal.find(
                                                                    (entry) =>
                                                                        entry.monthName === month.monthName &&
                                                                        entry.year === month.year
                                                                );

                                                                const count = monthlyData?.count || 0;
                                                                const leadIds = monthlyData?.leadIds || [];

                                                                return (
                                                                    <TableCell
                                                                        className={classes.bordercolors}
                                                                        key={dataIndex}
                                                                        style={{
                                                                            textAlign: "center",
                                                                            cursor: "pointer",
                                                                            color: expCenterIndex === uniqueexperienceCenterNames.length - 1
                                                                                ? "#355025"
                                                                                : "#1C375D",
                                                                            textDecoration: "underline",
                                                                            background: "white",
                                                                            fontWeight:
                                                                                expCenterIndex === uniqueexperienceCenterNames.length - 1
                                                                                    ? "bolder"
                                                                                    : "normal",
                                                                        }}
                                                                        onClick={(e) =>
                                                                            getDataBasedOnClickMarketing(
                                                                                e,
                                                                                month,
                                                                                innerEl,
                                                                                leadIds,
                                                                                "leads"
                                                                            )
                                                                        }
                                                                    >
                                                                        {formatNumberToTwoDecimalPlaces(count)}
                                                                    </TableCell>
                                                                );
                                                            })}
                                                        </>
                                                    ))}
                                                </TableRow>
                                            ))}

                                            <TableRow>
                                                <TableCell
                                                    className={classes.cell}
                                                    style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}
                                                >
                                                    <strong>Grand Total</strong>
                                                </TableCell>

                                                {uniqueexperienceCenterNames.map((experienceCenterName, index) => {

                                                    const centerData = store.find(
                                                        el => el.experienceCenterName === experienceCenterName
                                                    );

                                                    const count = centerData?.count || 0;
                                                    const leadIds = centerData?.leadIds || [];

                                                    return (
                                                        <TableCell
                                                            className={classes.bordercolors}
                                                            key={index}
                                                            style={{
                                                                textAlign: "center",
                                                                cursor: "pointer",
                                                                color: "#004d40",
                                                                zIndex: 1,
                                                                textDecoration: "underline",
                                                                fontWeight: "bolder",
                                                                background: "white"
                                                            }}
                                                            onClick={(e) =>
                                                                getDataBasedOnClickMarketing(
                                                                    e,
                                                                    store[0].monthlyGrandTotal,
                                                                    experienceCenterName,
                                                                    leadIds,
                                                                    "total"
                                                                )
                                                            }
                                                        >
                                                            {formatNumberToTwoDecimalPlaces(count)}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        </>
                                    )}
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </div>
                </Paper>
                <div style={{ marginTop: "20px" }}>
                    <Paper style={{ marginTop: "20px", padding: "20px", borderRadius: "12px" }}>
                        <LeadSourceTypeBookingsReport
                            startDate={storeDateFilter.startDate}
                            endDate={storeDateFilter.endDate}
                            dateType={storeDateFilter.dateType}
                        />
                    </Paper>
                </div>
            </div>
            <Modal
                title={"Lead Generated Data"}
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width="96vw"
                // top 24 + the 70px of antd chrome (content padding + header) is
                // subtracted from the body below, which leaves an equal 24px gap
                // at the bottom - so the modal sits centred in both axes while
                // still filling the screen. margin:0 auto handles the horizontal.
                style={{ top: 24, maxWidth: 1760, paddingBottom: 0, margin: "0 auto" }}
                bodyStyle={{
                    // The body is a fixed-height flex column: the progress slot,
                    // banner and toolbar keep their natural height and the table
                    // takes everything that is left. That is what makes the count
                    // and Download CSV stay put while only the rows scroll.
                    height: "calc(100vh - 118px)",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
                maskClosable={true}
                footer={null}
            >
                {/* Reserved slot so the toolbar doesn't shift when the fetch
                    starts. */}
                <div style={{ height: 4, borderRadius: 999, overflow: "hidden", marginBottom: 10, flexShrink: 0 }}>
                    {modalDataLoading ? <BrandLinearProgress /> : null}
                </div>

                {/* Says plainly what is happening - the skeleton rows below show
                    shape but not intent. */}
                {modalDataLoading && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            marginBottom: 12,
                            padding: "10px 14px",
                            borderRadius: 10,
                            background: "#FFF4ED",
                            border: "1px solid #f6d3bd",
                            flexShrink: 0,
                        }}
                    >
                        <CircularProgress size={17} thickness={5} style={{ color: ORANGE_DARK }} />
                        <div style={{ minWidth: 0 }}>
                            <div style={{ fontSize: 13, fontWeight: 700, color: ORANGE_DARK }}>
                                Loading leads…
                            </div>
                            <div style={{ fontSize: 11.5, color: "#7a6a60" }}>
                                Pulling every lead behind this number — this can take a few seconds on a wide date range.
                            </div>
                        </div>
                    </div>
                )}

                {/* Pinned toolbar: flexShrink 0 keeps it out of the scroll area
                    entirely, so the lead count and Download CSV remain reachable
                    however far down the rows you are. */}
                <div
                    className={classes.csv}
                    style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12, flexShrink: 0 }}
                >
                    <Chip
                        size="small"
                        label={
                            modalDataLoading
                                ? "Fetching…"
                                : `${popMonthData?.length || 0} lead${(popMonthData?.length || 0) === 1 ? "" : "s"}`
                        }
                        style={{
                            marginRight: "auto",
                            fontWeight: 700,
                            background: "#FFF1EA",
                            color: ORANGE_DARK,
                            border: `1px solid ${ORANGE}44`,
                        }}
                    />
                    <CSVLink
                        headers={headers}
                        filename={`${"lead_generated_data"}.csv`}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    {!isMarketingAnalyst && <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        disabled={modalDataLoading || !popMonthData?.length}
                        startIcon={modalDataLoading ? <CircularProgress size={15} style={{ color: "#fff" }} /> : null}
                        style={{
                            // Muted while disabled - a full-strength button that
                            // does nothing is worse than an obviously inactive one.
                            backgroundColor: (modalDataLoading || !popMonthData?.length) ? "#c9d0db" : "#355025",
                            color: "#FFF2EB",
                            marginRight: "10px",
                        }}
                        variant="contained"
                        color="secondary"
                    >
                        {modalDataLoading ? "Loading…" : "Download CSV"}
                    </Button>}
                </div>
                {/* With nothing to show, the 47-column table is skipped entirely -
                    a colSpan row inside it would centre the message across the full
                    table width, so you would have to scroll sideways to read it. */}
                {!modalDataLoading && !popMonthData?.length ? (
                    <Paper
                        style={{
                            flex: 1,
                            minHeight: 0,
                            overflow: "auto",
                            borderRadius: 12,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <div style={{ width: "100%" }}>
                            {renderNoDataState({
                                title: "No leads behind this number",
                                hint: "The cell you clicked has no leads left once these filters are applied.",
                            })}
                        </div>
                    </Paper>
                ) : (
                    // The bounded height `stickyHeader` needs now comes from the
                    // flex column above (flex 1 + minHeight 0) rather than a fixed
                    // vh figure, so the table always fills the rest of the modal.
                    // classes.table is deliberately NOT on the container: it is
                    // `width: fit-content`, which sized the container to the full
                    // 47-column table, so nothing ever overflowed and there was
                    // no horizontal scrollbar to drag.
                    <TableContainer
                        component={Paper}
                        style={{
                            flex: 1,
                            minHeight: 0,
                            width: "100%",
                            overflow: "auto",
                            marginBottom: 0,
                        }}
                    >
                        <Table
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Created At</StyledTableCell>
                                    <StyledTableCell>Lead Assigned Date</StyledTableCell>
                                    <StyledTableCell>Source of Lead</StyledTableCell>
                                    <StyledTableCell>Secondary Source of Lead</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    {/* <StyledTableCell>Client Phone Number</StyledTableCell> */}
                                    {/* <StyledTableCell>Client Email</StyledTableCell> */}
                                    <StyledTableCell>Assigned To</StyledTableCell>
                                    <StyledTableCell>Address</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Design Won Date</StyledTableCell>
                                    <StyledTableCell>Completion Date</StyledTableCell>
                                    <StyledTableCell>Current Department</StyledTableCell>
                                    <StyledTableCell>Current Stage</StyledTableCell>
                                    <StyledTableCell>Lead Type</StyledTableCell>
                                    <StyledTableCell>Lost Post Meeting</StyledTableCell>
                                    <StyledTableCell>Token % Received</StyledTableCell>
                                    <StyledTableCell>Requirements Not Collected Movement Date</StyledTableCell>
                                    <StyledTableCell>Reason for lead to be in Requirements Not Collected Stage</StyledTableCell>
                                    <StyledTableCell>Lead Verification Status</StyledTableCell>
                                    <StyledTableCell>Requirement Collection Date</StyledTableCell>
                                    <StyledTableCell>Requirements Collected Stage Movement Date</StyledTableCell>
                                    <StyledTableCell>Reason for lead to stay in Requirements Collected Stage </StyledTableCell>
                                    <StyledTableCell>Scope of work in detail</StyledTableCell>
                                    <StyledTableCell>Design Preferences Details</StyledTableCell>
                                    <StyledTableCell>Budget Details</StyledTableCell>
                                    <StyledTableCell>Timeline to move into the house</StyledTableCell>
                                    <StyledTableCell>Possession Date</StyledTableCell>
                                    <StyledTableCell>Attach Floor Plan link</StyledTableCell>
                                    <StyledTableCell>Any other specific details relevant to Decorpot</StyledTableCell>
                                    <StyledTableCell>Proposed Meeting Type</StyledTableCell>
                                    <StyledTableCell>Proposed Meeting Date</StyledTableCell>
                                    <StyledTableCell>Proposed Meeting Participant</StyledTableCell>
                                    <StyledTableCell>Quotation Sent Movement Date</StyledTableCell>
                                    <StyledTableCell>Reason for deal to be in Quotation Sent stage</StyledTableCell>
                                    <StyledTableCell>Is Quotation fitting customer budget mentioned </StyledTableCell>
                                    <StyledTableCell>Is customer planning to visit the Experience Zone</StyledTableCell>
                                    <StyledTableCell> Latest Notes </StyledTableCell>
                                    <StyledTableCell> Latest Notes Date </StyledTableCell>
                                    <StyledTableCell> Latest Deal Activity</StyledTableCell>
                                    <StyledTableCell> Latest Deal Activity Date </StyledTableCell>
                                    <StyledTableCell> Reason for Lost</StyledTableCell>
                                    <StyledTableCell> Total Count Quotation Open by Cx</StyledTableCell>


                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {/* Placeholder rows while the fetch runs, so the wide
                                    table keeps its shape instead of rendering empty.
                                    ACTIVE_MODAL_COLUMNS counts only the headers that
                                    are actually rendered - two are commented out, and
                                    counting those would leave ragged trailing cells. */}
                                {modalDataLoading && Array.from({ length: 8 }).map((_, r) => (
                                    <StyledTableRow key={`sk-${r}`}>
                                        {Array.from({ length: ACTIVE_MODAL_COLUMNS }).map((__, c) => (
                                            <StyledTableCell key={c}>
                                                <Skeleton variant="text" width={c === 0 ? 26 : 62} />
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                ))}
                                {!modalDataLoading && popMonthData && popMonthData.map((data, i) => {
                                    return (
                                        <>

                                            <StyledTableRow key={i}>
                                                <StyledTableCell>{i + 1}</StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.erpProjectNo ? (
                                                        <Link
                                                            to={`/project-logs/${data?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.erpProjectNo}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.lead_no ? (
                                                        <Link
                                                            to={`/project-logs/${data?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.lead_no}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.createdAt ? formatDate(data?.createdAt) : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadAssignedDate ? formatDate(data?.leadAssignedDate) : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.sourceOfLead?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {formatSecondarySources(data, "-")}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.customerId?.name}
                                                </StyledTableCell>
                                                {/* <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.customerId?.contact_no}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.customerId?.email}
                                                </StyledTableCell> */}
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.assignTo?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.customerId?.address}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.staticSalesWonBudget ? data?.staticSalesWonBudget : "N/A"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.experienceCenterId?.locationId?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.experienceCenterId?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadWonDate ? moment(data?.leadWonDate).format("DD-MM-YYYY") : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.customerDesignSignOffDate ? moment(data?.customerDesignSignOffDate).format("DD-MM-YYYY") : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.executionCompletionDate ? moment(data?.executionCompletionDate).format("DD-MM-YYYY") : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.departmentId ? data.departmentId?.name : 'NA'}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.currentStage ? data.currentStage : 'NA'}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadType ? data.leadType : 'NA'}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.isLost?.length > 0
                                                        ? data.isLost[0]?.isLostPostMeeting === true
                                                            ? "Yes"
                                                            : data.isLost[0]?.isLostPostMeeting === false
                                                                ? "No"
                                                                : "NA"
                                                        : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.tokenPercent !== null ? data?.tokenPercent : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th"> {data?.salesStageData?.reqNotCollectedData?.moveDateInRnc ? moment(data.salesStageData.reqNotCollectedData.moveDateInRnc).format("DD-MM-YYYY") : "-"} </StyledTableCell>
                                                <StyledTableCell component="th"> {data?.salesStageData?.reqNotCollectedData?.reasonToMove || "-"} </StyledTableCell>
                                                <StyledTableCell component="th"> {data?.salesStageData?.reqNotCollectedData?.verifyStatus || "-"} </StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.reqCollectedData?.reqCollectionDate ? moment(data?.salesStageData?.reqCollectedData?.reqCollectionDate).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.reqCollectedData?.moveDateInReqCol ? moment(data?.salesStageData?.reqCollectedData?.moveDateInReqCol).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.reqCollectedData?.reasonMoveRcCollect || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.reqCollectedData?.rcScopeOfWork || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.reqCollectedData?.designPref || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.reqCollectedData?.estimatedBudget || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.reqCollectedData?.timelineMoveHouseDate ? moment(data?.salesStageData?.reqCollectedData?.timelineMoveHouseDate).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.reqCollectedData?.possDate ? moment(data?.salesStageData?.reqCollectedData?.possDate).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.salesStageData?.reqCollectedData?.floorPlanAttach ?
                                                        <DownloadOutlined
                                                            onClick={() => window.open(data?.salesStageData?.reqCollectedData?.floorPlanAttach)}
                                                            style={{ color: "green", cursor: "pointer", fontWeight: "bold", fontSize: '24px' }}
                                                        /> : '-'
                                                    }
                                                </StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.reqCollectedData?.rcOtherDetails || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.qtSentMeetingDetail?.proposeMeetingType ? data?.salesStageData?.qtSentMeetingDetail?.proposeMeetingType : 'NA'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.qtSentMeetingDetail?.proposeMeetingDate ? moment(data?.salesStageData?.qtSentMeetingDetail?.proposeMeetingDate).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.qtSentMeetingDetail?.meetingParticipant ? data?.salesStageData?.qtSentMeetingDetail?.meetingParticipant : 'NA'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.qtSentData?.moveDateQtSent ? moment(data?.salesStageData?.qtSentData?.moveDateQtSent).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.qtSentData?.reasonForDealQt || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.qtSentData?.qtFitBudget || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.salesStageData?.qtSentData?.cxPlanDateVisitStatus || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.latestNotesMsg  || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{moment(data?.latestNotesDate).format('DD-MM-YYYY')  || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.latestDealMsg  || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{moment(data?.latestDealDate).format('DD-MM-YYYY')  || '-'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.reasonForLost ? data?.reasonForLost : 'Not Lost'}</StyledTableCell>
                                                <StyledTableCell component="th">{data?.quotationOpenCount ?? 0}</StyledTableCell>
                                            </StyledTableRow>
                                        </>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(LeadsGenerated);